'use client'

import ICasino, { getMinBet } from '../../models/ICasino'
import { Divider, Grid, Stack } from '@mui/material';

import CasinoMinBet from './CasinoMinBet';
import { useAppState } from '../../reduxish/appState';


/**
 * This is a React functional component that renders the casino data in the list of casinos.
 * @returns {JSX.Element}
 */
export default function CasinoMinBets({ casino }: { casino: ICasino }) {
    const { state: { userPreferences: { displayCraps, displayBlackjack, displayRoulette } } } = useAppState();

    return (
        <>
            <Stack direction={'column'} sx={{ display: { xs: 'none', md: 'flex' } }} spacing={4}>
                {displayCraps && <CasinoMinBet minBet={getMinBet(casino, 'craps')} minBetType='Craps' />}
                {displayBlackjack && <CasinoMinBet minBet={getMinBet(casino, 'blackjack')} minBetType='Blackjack' />}
                {displayRoulette && <CasinoMinBet minBet={getMinBet(casino, 'roulette')} minBetType='Roulette' />}
            </Stack>
            <Stack direction={'column'} sx={{ display: { xs: 'flex', md: 'none' } }}>
                {displayCraps && <CasinoMinBet minBet={getMinBet(casino, 'craps')} minBetType='Craps' />}
                {displayBlackjack && <CasinoMinBet minBet={getMinBet(casino, 'blackjack')} minBetType='Blackjack' />}
                {displayRoulette && <CasinoMinBet minBet={getMinBet(casino, 'roulette')} minBetType='Roulette' />}
            </Stack>
        </>
    );
}
